import { render, staticRenderFns } from "./Ontwikkeling.vue?vue&type=template&id=2d61ef86&scoped=true&"
import script from "./Ontwikkeling.vue?vue&type=script&lang=js&"
export * from "./Ontwikkeling.vue?vue&type=script&lang=js&"
import style0 from "./Ontwikkeling.vue?vue&type=style&index=0&id=2d61ef86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d61ef86",
  null
  
)

export default component.exports